import { defineComponent, h, computed } from 'vue'
import { VIcon as VuetifyVIcon } from 'vuetify/components'
import { normalizeIconName } from '@/utils/iconCompat'

/**
 * Vuetify VIcon expects `icon`; Vuestic used `name`. This wrapper accepts both.
 */
export const CompatVIcon = defineComponent({
  name: 'VIcon',
  inheritAttrs: false,
  props: {
    ...VuetifyVIcon.props,
    name: {
      type: [String, Object, Function, Array] as unknown as () => string,
      default: undefined,
    },
  },
  setup(props, { attrs, slots }) {
    const resolvedIcon = computed(() => {
      const raw = props.icon ?? props.name
      if (typeof raw === 'string') {
        return normalizeIconName(raw)
      }
      return raw
    })

    return () => {
      const { name: _legacyName, ...btnProps } = props

      return h(
        VuetifyVIcon,
        {
          ...attrs,
          ...btnProps,
          icon: resolvedIcon.value,
        },
        slots,
      )
    }
  },
})
